import "babel-regenerator-runtime"
import jsCookie from "js-cookie"

import * as perfTracker from "common/utils/perfTracker"
import "common/browser/babelIE10"
import "common/browser/utils/customPolyfills"

import "common/browser/clientConfig"
import "common/browser/utils/onload"
import "common/browser/utils/trackBeforeImports" // must be after config, because of cuckoo

import store from "./store"
import history from "./history"
import browserInfo from "common/browser/utils/browserInfo"
import oauthRedirect from "common/browser/utils/oauthRedirect"
import initAffiliates from "common/browser/utils/initAffiliates"
import cuckoo from "common/services/cuckoo/cuckoo"
import { isSetAffilId } from "common/services/affilId/tools"
import { cuckooEvents } from "common/consts/enums"
import adara from "common/services/tracking/adara"
import constants from "common/consts/config"
import featureDetection from "common/utils/featureDetection"

if (__DEV__) {
  const _ = require("lodash") // eslint-disable-line
  window._ = _
}

// COMMON - PART 1
// ===
perfTracker.onPageLoaded()
const timeFromBegin = perfTracker.getBeginToPageLoadedDuration()

initAffiliates()

cuckoo.track(cuckooEvents.GENERAL_PAGE_LOADED, { ...browserInfo, timeFromBegin })
if (typeof window.smartlook !== "undefined") {
  window.smartlook("tag", "browser", browserInfo.browser)
  window.smartlook("tag", "os", browserInfo.os)
}

featureDetection()

// COMMON - PART 2
// ===
if (window.location.search.match(/oauth-login/)) {
  oauthRedirect() // sets cookies, run before 'initReact'
}

window.addEventListener("beforeunload", () => {
  const page = window.SP_GLOBALS.SKYPICKER_PAGE_NAME
  cuckoo.track(cuckooEvents.GENERAL_PAGE_LEFT, { page })
})

// COMMON - PART 3
// ===
adara.trackHomePage()

if (isSetAffilId("aw")) {
  ;(function() {
    const s = document.getElementsByTagName("script")[0]
    const e = document.createElement("script")
    e.type = "text/javascript"
    // noinspection SpellCheckingInspection
    e.src = `//www.dwin1.com/${constants.affiliateWindowAdvertiserId}.js`
    e.defer = "defer"
    s.parentNode.insertBefore(e, s)
  })()
}

// Add ui to cookies, so every other request is also webview
const ui = window.getEnvParameter("ui")
if (ui) {
  jsCookie.set("ui", ui)
}

perfTracker.onAppInitialized()
cuckoo.track(cuckooEvents.GENERAL_PAGE_INITIALIZED, {
  timeFromBegin: perfTracker.getBeginToAppInitializedDuration(),
})

// FIXME stop using globals
window.reduxStore = store // for debugging
window.browserHistory = history
